import { defineMessages } from '../define';

export default defineMessages({
  'invite.share.text': {
    ru: 'Собираю вертикальные ролики из записи на камеру за пару минут: субтитры, хук, врезки и музыка. Попробуй:',
    en: 'I turn on-camera recordings into vertical reels in a couple of minutes: subtitles, hook, cutaways and music. Try it:',
  },
  'invite.status.pending': { ru: 'Заявка принята', en: 'Request received' },
  'invite.status.processing': { ru: 'В обработке', en: 'Processing' },
  'invite.status.paid': { ru: 'Выплачено', en: 'Paid' },
  'invite.status.rejected': { ru: 'Отклонено', en: 'Rejected' },
  'invite.weekdays.0': { ru: 'вс', en: 'Sun' },
  'invite.weekdays.1': { ru: 'пн', en: 'Mon' },
  'invite.weekdays.2': { ru: 'вт', en: 'Tue' },
  'invite.weekdays.3': { ru: 'ср', en: 'Wed' },
  'invite.weekdays.4': { ru: 'чт', en: 'Thu' },
  'invite.weekdays.5': { ru: 'пт', en: 'Fri' },
  'invite.weekdays.6': { ru: 'сб', en: 'Sat' },
  'invite.chart.aria': { ru: 'Приглашённые по дням за неделю', en: 'Invited friends per day this week' },
  'invite.toast.withdrawal': { ru: 'Заявка на вывод принята', en: 'Withdrawal request received' },
  'invite.toast.copied': { ru: 'Ссылка скопирована', en: 'Link copied' },
  'invite.toast.copyFailed': { ru: 'Не удалось скопировать, выделите ссылку вручную', en: 'Could not copy. Select the link manually' },
  'invite.title': { ru: 'Приглашайте друзей', en: 'Invite friends' },
  'invite.lead': {
    ru: 'Получайте 25% от первой покупки подписки приглашённого друга в Telegram Stars. Звёзды накапливаются на реферальном балансе.',
    en: 'Get 25% of your invited friend’s first subscription purchase in Telegram Stars. Stars build up on your referral balance.',
  },
  'invite.link.label': { ru: 'Ваша ссылка', en: 'Your link' },
  'invite.link.missing': { ru: 'Ссылка появится, когда в окружении API будет задан BOT_USERNAME.', en: 'The link will appear once BOT_USERNAME is set in the API environment.' },
  'invite.share': { ru: 'Поделиться', en: 'Share' },
  'invite.copy': { ru: 'Скопировать', en: 'Copy' },
  'invite.stat.invited': { ru: 'приглашено', en: 'invited' },
  'invite.stat.commission': { ru: 'с первой покупки', en: 'of first purchase' },
  'invite.withdraw.title': { ru: 'Вывод звёзд', en: 'Withdraw Stars' },
  'invite.withdraw.available': { ru: 'Доступно к выводу', en: 'Available to withdraw' },
  'invite.withdraw.paid': { ru: 'Выплачено', en: 'Paid out' },
  'invite.withdraw.info': {
    ru: 'По заявке отправляем Telegram Stars на ваш аккаунт — от {min}. Дробные звёзды остаются на балансе. Выплаты обрабатываются вручную.',
    en: 'On request we send Telegram Stars to your account, from {min}. Fractional stars stay on your balance. Payouts are processed manually.',
  },
  'invite.withdraw.reserved': { ru: 'В заявке: {amount}', en: 'In request: {amount}' },
  'invite.withdraw.debt': {
    ru: 'После возврата оплаты нужно восполнить {amount}. Новые начисления погасят эту сумму.',
    en: 'After a refund, {amount} needs to be covered. New earnings will pay it off.',
  },
  'invite.withdraw.sending': { ru: 'Отправляем…', en: 'Sending…' },
  'invite.withdraw.request': { ru: 'Подать заявку на вывод', en: 'Request withdrawal' },
  'invite.withdraw.support': { ru: 'Связаться с поддержкой', en: 'Contact support' },
  'invite.withdraw.number': { ru: '№ {id}', en: '#{id}' },
  'invite.week.title': { ru: 'За 7 дней', en: 'Last 7 days' },
  'invite.week.empty': { ru: 'По ссылке за эту неделю никто не пришёл — здесь появится график.', en: 'Nobody has joined through your link this week. A chart will appear here.' },
  'invite.footnote': {
    ru: 'Комиссия начисляется после подтверждения первой покупки подписки. За оплату рублями считаем 25% от цены тарифа в Stars. Продления и докупки не учитываются. При возврате оплаты комиссия отменяется.',
    en: 'The commission is credited once the first subscription purchase is confirmed. For payments in rubles we count 25% of the plan’s price in Stars. Renewals and top-ups do not count. If a payment is refunded, the commission is cancelled.',
  },
});
